import Stack from '~/common/components/Stacks/Stack';

import { TITLE_ICON_TYPE } from '../../QuestionBox/constants';
import DetailedAnswer from './DetailedAnswer';
import ExtractionDataIcon from './ExtractionDataIcon';

type ConfidenceFooterProps = {
  detailedAnswer?: string;
  confidenceLevel?: string | number;
  handleConfidenceLevelColor?: (...args: any[]) => any;
  showGaugeIcon?: boolean;
};

const ConfidenceFooter = ({
  detailedAnswer = '',
  confidenceLevel = 0,
  handleConfidenceLevelColor = () => {},
  showGaugeIcon,
}: Readonly<ConfidenceFooterProps>) => {
  const iconColor = handleConfidenceLevelColor(confidenceLevel);
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'left',
        alignItems: 'center',
        width: '100%',
        paddingTop: '1rem',
      }}
    >
      {showGaugeIcon && (
        <ExtractionDataIcon
          isConfidence={true}
          data-tracking="show-context"
          sx={{ fontSize: 'clamp(1.5rem, 1.5rem, 2rem)' }}
          iconType={TITLE_ICON_TYPE.GAUGE}
          color={iconColor}
        />
      )}
      {!!detailedAnswer && <DetailedAnswer detailedAnswer={detailedAnswer} />}
    </Stack>
  );
};

export default ConfidenceFooter;
